import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActiveModulesList = ({ modules, onViewDetails }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Active Modules</h2>
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
          {modules?.length} Active
        </span>
      </div>
      <div className="space-y-3">
        {modules?.map((module) => (
          <div
            key={module.id}
            className="flex items-center justify-between p-4 bg-muted/50 rounded-lg hover:bg-muted transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name={module.icon} size={20} color="var(--color-primary)" />
              </div>
              <div>
                <p className="font-medium text-foreground">{module.name}</p>
                <p className="text-xs text-muted-foreground">{module.locations} locations</p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              iconName="ChevronRight"
              iconPosition="right"
              onClick={() => onViewDetails(module)}
            >
              View
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveModulesList;